import { useEffect, useState } from 'react';
import Sheet from '../components/Sheet';
import Icon from '../components/Icon';
import { PRIMARY } from '../components/CaptureSheets';
import { copyText, qrDataUrl, shareLink } from '../lib/coach';
import { useApp } from '../lib/AppContext';

const SEES = ['Thực đơn các bữa ăn chung', 'Khẩu phần tính theo mục tiêu của chính họ', 'Danh sách đi chợ gộp 2 người'];
const HIDDEN = 'Cân nặng, nhật ký, tiến độ của bạn';
const TILE = 'flex flex-col items-center gap-1.5 text-xs font-semibold';
const ICON = 'grid size-14 place-items-center rounded-[16px]';

// ② "Nấu chung": who sees what, then a one-time link (Zalo, Messenger, QR, copy). The link is made when the
// sheet opens (a new one each time; the previous pending one stops working). `intent`: "fresh" from an empty
// menu tab (the inviter waits to make the menu for two), "existing" otherwise.
export default function InviteSheet({ open, intent = 'existing', onClose, onSent }) {
  const { api } = useApp();
  const [invite, setInvite] = useState(null);
  const [qr, setQr] = useState(null);
  const [note, setNote] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open) return;
    setInvite(null);
    setQr(null);
    setNote(null);
    setError(null);
    api.post('/pair_invites', { intent }).then((d) => { setInvite(d.invite); onSent?.(d.invite); }).catch((e) => setError(e.message));
  }, [open, api, intent]); // eslint-disable-line react-hooks/exhaustive-deps

  const url = invite?.url;
  const text = 'Nấu chung với mình trên Macro Mate nhé: một thực đơn, mỗi người một khẩu phần.';
  const share = async () => {
    const done = await shareLink({ title: 'Nấu chung', text, url });
    if (done === 'copied') setNote('Đã sao chép link');
  };
  // Zalo and Messenger have no web share link without an app id: both open the phone's share sheet, where
  // they are listed (or copy the link where there is none).
  const zalo = share;
  const messenger = share;
  const showQr = async () => setQr(await qrDataUrl(url));

  return (
    <Sheet open={open} onClose={onClose} title="">
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-3">
          <span className="grid size-12 place-items-center rounded-[14px] bg-[#fdf0e6] text-[#c2410c]"><Icon name="bowl" className="size-6" /></span>
          <div>
            <p className="text-lg font-bold">Nấu chung</p>
            <p className="text-sm text-muted">Một thực đơn, mỗi người một khẩu phần</p>
          </div>
        </div>
        <div className="rounded-[16px] bg-base-200 p-4 text-sm">
          <p className="pb-2 font-bold">Người được mời sẽ thấy</p>
          <ul className="flex flex-col gap-1.5">
            {SEES.map((s) => <li key={s} className="flex gap-2"><Icon name="check" className="size-4 shrink-0 text-brand-text" />{s}</li>)}
            <li className="flex gap-2"><Icon name="x" className="size-4 shrink-0 text-error" />{HIDDEN}</li>
          </ul>
        </div>
        {qr ? (
          <div className="flex flex-col items-center gap-2">
            <img src={qr} alt="Mã QR lời mời nấu chung" className="size-56 rounded-[16px] border border-line" />
            <button type="button" className="btn btn-ghost h-11 rounded-2xl" onClick={() => setQr(null)}>Quay lại</button>
          </div>
        ) : (
          <div>
            <p className="pb-2 text-sm font-bold">Gửi lời mời qua</p>
            <div className="grid grid-cols-4 gap-2">
              <button type="button" className={TILE} disabled={!url} onClick={zalo}>
                <span className={`${ICON} bg-[#e5f0ff] text-[13px] font-extrabold text-[#0068ff]`}>Zalo</span>Zalo
              </button>
              <button type="button" className={TILE} disabled={!url} onClick={messenger}>
                <span className={`${ICON} bg-[#efe8ff] text-[#7b3fe4]`}><Icon name="send" className="size-6" /></span>Messenger
              </button>
              <button type="button" className={TILE} disabled={!url} onClick={showQr}>
                <span className={`${ICON} bg-[#17201b] text-white`}><Icon name="qr" className="size-6" /></span>Mã QR
              </button>
              <button type="button" className={TILE} disabled={!url} onClick={async () => { await copyText(url); setNote('Đã sao chép link'); }}>
                <span className={`${ICON} bg-base-200`}><Icon name="copy" className="size-6" /></span>Sao chép
              </button>
            </div>
          </div>
        )}
        {!url && !error && <p className="flex items-center justify-center gap-2 text-sm text-muted"><span className="loading loading-spinner loading-xs" /> Đang tạo link…</p>}
        {note && <p role="status" className="text-center text-sm font-semibold text-brand-text">{note}</p>}
        {error && <p role="alert" className="text-center text-sm font-medium text-error">{error}</p>}
        <p className="text-center text-xs text-muted">Tối đa 2 người. Link dùng 1 lần, hết hạn sau 7 ngày.</p>
        <button type="button" className={PRIMARY} onClick={onClose}>Xong</button>
      </div>
    </Sheet>
  );
}
